// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__GvyKm","badge--secondary":"badge_badge--secondary__bf87B","badge--tertiary":"badge_badge--tertiary__rpmn2"};